module.exports = __webpack_public_path__ + "static/img/background.c9658aae.svg";